import React, { memo } from 'react';
import { BlockContainer } from '../BlockContainer';
import classNames from 'classnames';
import { formGroup, formControl, FormDataType, formArray } from '@core/utils/form';
import { Container } from 'reactstrap';
import { FormInput } from '@core/components/form';
import { CourseBuilder } from '../types';
import './index.scss';

function defineSignerBlockItemForm(terms: number) {
  return formGroup({
    email: formControl<string>({}),
  });
}

function defineSignerBlockForm(terms: number) {
  return formGroup({
    items: formArray(() => defineSignerBlockItemForm(terms)),
  });
}
export type SignerWidgetItemFormData = FormDataType<typeof defineSignerBlockItemForm>;
export type SignerWidgetFormData = FormDataType<typeof defineSignerBlockForm>;
export type SignerWidgetForm = ReturnType<typeof defineSignerBlockForm>;

export enum BlockTemplateBlockVariation {
  blockTemplate = 'Block Template',
}

export const BlockTemplateBlock = memo((props: CourseBuilder.BlockProps<BlockTemplateBlockVariation>) => {
  const { variation, preview } = props;

  return (
    <BlockContainer className={classNames('block-signer', variation, preview)}>
      <Container>
        <div style={{ display: 'flex' }}>
          {(props.editable || props.preview) && (
            <div className="signer-centered" style={{ flex: 1 }}>
              <FormInput control={formControl({ placeholder: 'John Smith' })} editable={false} disabled={true} />
            </div>
          )}
        </div>
      </Container>
    </BlockContainer>
  );
});
